import templateConfig from 'app/template.config';

import { LoginData, User, UserType } from 'store/models/user';

interface UserParams {
    userType: string;
    employerId: string | undefined;
}

interface VisitParams {
    newEmployer?: string;
    newManager?: string;
}

declare global {
    interface Window {
        ym: (counterId: number, paramsType: string, params: UserParams | VisitParams) => void;
    }
}

export const setParamsByUser = ({ userType, employerId }: User, { isNewEmployer, isNewManager }: LoginData): void => {
    const userParams: UserParams = {
        userType: userType.toLowerCase(),
        employerId: employerId?.toString(),
    };

    const visitParams: VisitParams = {};

    if (userType === UserType.Employer) {
        visitParams.newEmployer = isNewEmployer ? 'employer_new' : 'employer_already_was';
        visitParams.newManager = isNewManager ? 'manager_new' : 'manager_already_was';
    }

    window.ym(templateConfig.YA_MEASUREMENT_ID, 'userParams', userParams);

    if (Object.keys(visitParams).length > 0) {
        window.ym(templateConfig.YA_MEASUREMENT_ID, 'params', visitParams);
    }
};

export default setParamsByUser;
